// Mirrors backend/audit_rounds.py so Step 3 reflects unsaved edits; the backend remains the source of truth at sign-off.
export const FRESH_DAYS = 60;
export const STALE_DAYS = 90;

export const FRESH_META = {
  fresh: { label: "Up to date", cls: "bg-rag-green-bg text-rag-green border-rag-green/30" },
  due_soon: { label: "Review due soon", cls: "bg-rag-amber-bg text-rag-amber border-rag-amber/40" },
  overdue: { label: "Review overdue", cls: "bg-rag-red-bg text-rag-red border-rag-red/40" },
  no_date: { label: "Date audited needed", cls: "bg-cream text-muted-foreground border-cream-deep" },
};

export function freshness(dateAudited, today = new Date()) {
  if (!dateAudited) return { status: "no_date", days: null };
  const d = new Date(dateAudited);
  if (Number.isNaN(d.getTime())) return { status: "no_date", days: null };
  const days = Math.floor((Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()) - Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())) / 86400000);
  if (days <= FRESH_DAYS) return { status: "fresh", days };
  if (days <= STALE_DAYS) return { status: "due_soon", days };
  return { status: "overdue", days };
}

const staleOf = (rows) => rows.filter((x) => x.status !== "not_started" && ["overdue", "no_date"].includes(freshness(x.date_audited).status))
  .map((x) => `${x.label}: ${FRESH_META[freshness(x.date_audited).status].label.toLowerCase()}${x.date_audited ? ` (audited ${x.date_audited})` : ""}`);

// No/Partially need an action and N/A needs a reason — same rule as backend resident_note_issues()
export function residentNoteIssues(residents, resTpl) {
  const out = [];
  resTpl.forEach((d) => Object.entries(residents || {}).forEach(([k, r]) => {
    const saved = r?.answers?.[d.key] || {};
    d.items.forEach((item, i) => {
      const v = saved.items?.[i]; const note = (saved.actions?.[i] || "").trim();
      if (["no", "partial"].includes(v) && !note) out.push(`${r?.label || `Resident ${String(k).replace("closed-", "")}`} · ${d.title}: action needed for “${item}”`);
      else if (v === "na" && !note) out.push(`${r?.label || `Resident ${String(k).replace("closed-", "")}`} · ${d.title}: reason needed for N/A on “${item}”`);
    });
  }));
  return out;
}

// Open round if complete, otherwise latest closed complete round; valid only when every audit date is ≤90 days old.
export function supportingRound({ openRows, sampleSize, currentRound, closedRounds }) {
  const audited = openRows.filter((x) => x.status !== "not_started").length;
  let cand = null;
  if (sampleSize > 0 && audited >= sampleSize) cand = { source: "open", round_no: currentRound?.round_no || 1, started_at: currentRound?.started_at, closed_at: null, rows: openRows, audited, sample_size: sampleSize };
  else {
    const rd = (closedRounds || []).find((r) => r.status === "complete");
    if (rd) cand = { source: "closed", round_no: rd.round_no, started_at: rd.started_at, closed_at: rd.closed_at, rows: rd.residents, audited: rd.audited, sample_size: rd.sample_size };
  }
  if (!cand) return { found: false, valid: false, stale: [], audited, sampleSize };
  const stale = staleOf(cand.rows);
  const dates = cand.rows.map((x) => x.date_audited).filter(Boolean).sort();
  return { found: true, valid: stale.length === 0, stale, audited, sampleSize, ...cand, first_date: dates[0] || null, last_date: dates[dates.length - 1] || null };
}
